import styled from '@emotion/styled/macro';
import { Box } from '@chakra-ui/react';
import theme from 'ui/theme/theme';

export const ContentContainer = styled.div`
  width: 100%;
  min-width: 0px;
  padding-left: 0px;
  margin-top: 30px;

  @media (min-width: ${theme.breakpoints.lg}) {
    padding-left: 10px;
    margin-top: 0px;
  }
`;

export const Wrapper = styled.div`
  min-width: 128px;
  max-width: 450px;
  padding: ${(props) => (props.padding ? `${props.padding}` : '8px 0px')};
  margin-top: ${(props) => (props.marginTop ? `${props.marginTop}` : '16px')};
  background: ${theme.colors.gray['50']};
  border-radius: 8px;
  display: none;

  @media screen and (min-width: ${theme.breakpoints.md}) {
    display: block;
  }
`;

export const AnswerBox = styled(Box)`
  boder: 1px solid ${theme.colors.gray['400']};
  border-radius: 8px;
  padding: 18px 12px 8px 18px;
  margin-top: 8px;
  margin-bottom: 4px;
`;
